import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyB6sviYh6GMZTTFaPyNQQsPd5Q_Qr4dza4",
  authDomain: "mudra-token.firebaseapp.com",
  projectId: "mudra-token",
  storageBucket: "mudra-token.firebasestorage.app",
  messagingSenderId: "195853434748",
  appId: "1:195853434748:web:5e94aafa8c6d9e4605eef9",
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);
export const functions = getFunctions(app);

// Connect to local emulator for testing
connectFunctionsEmulator(functions, "127.0.0.1", 5001);

export default app;